import React from 'react';
import { useSelector } from 'react-redux';
import RequestFormComponent from '@websky/core/src/Refund/Components/RequestForm/RequestForm';
import Notes from '@websky/core/src/Refund/Components/Notes/Notes';
import { getIsRefundVoluntary, isAutoRefundMode } from '@websky/core/src/Refund/store/selectors';
const RequestForm = props => {
    const isAutoMode = useSelector(isAutoRefundMode);
    const isVoluntaryRefund = useSelector(getIsRefundVoluntary);
    const renderNotes = () => {
        return React.createElement(Notes, { isAutoMode: isAutoMode, showReturnMessage: true });
    };
    return React.createElement(RequestFormComponent, Object.assign({}, props, { renderNotes: renderNotes, hiddenInputComment: isVoluntaryRefund }));
};
export default RequestForm;
